import { Box, Typography } from "@dealer-center/core-components";
import type { ListComponentProps } from "../../MasterDetailLayout";

export const TaskItemList = ({ onSelect, selectedId }: ListComponentProps) => (
  <Box>
    <Box sx={{ borderBottom: "1px solid", borderColor: "divider", p: 1.5 }}>
      <Typography sx={{ fontWeight: "bold" }} variant="body-md">
        Tasks
      </Typography>
    </Box>
    {["item-1", "item-2", "item-3"].map(id => (
      <Box
        key={id}
        role="button"
        sx={{
          backgroundColor:
            selectedId === id ? "action.selected" : "transparent",
          borderBottom: "1px solid",
          borderColor: "divider",
          cursor: "pointer",
          p: 1.5,
          "&:hover": { backgroundColor: "action.hover" }
        }}
        tabIndex={0}
        onClick={() => onSelect(id)}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === "Enter") onSelect(id);
        }}
      >
        <Typography variant="body-md">{id}</Typography>
        <Typography sx={{ color: "text.secondary" }} variant="body-sm">
          TODO: Tasks list item
        </Typography>
      </Box>
    ))}
  </Box>
);
